import React, { useEffect, useRef } from 'react';

type InputCheckboxProps = {
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  label?: string | React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  subtitle?: string | React.ReactNode;
  value?: string;
  variant?: 'check' | 'square';
};

const InputCheckbox = React.forwardRef<HTMLDivElement, InputCheckboxProps>(
  (
    {
      checked = false,
      disabled = false,
      indeterminate = false,
      label = '',
      onChange = () => {},
      onClick,
      subtitle = '',
      value,
      variant = 'check',
      ...props
    },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate;
      }
    }, [indeterminate]);

    return (
      <div
        className={`input-checkbox input-checkbox--${variant}`}
        ref={ref}
        onClick={onClick}
      >
        <label className="input-checkbox__label-wrapper">
          <input
            ref={inputRef}
            type="checkbox"
            className="input-checkbox__input"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            value={value}
            {...props}
          />
          <span className="input-checkbox__box" aria-hidden="true" />
          <div className="input-checkbox__texts">
            <span className="input-checkbox__label">{label}</span>
            {subtitle && <span className="input-checkbox__subtitle">{subtitle}</span>}
          </div>
        </label>
      </div>
    );
  }
);

InputCheckbox.displayName = 'InputCheckbox';

export default InputCheckbox;
